/**
 * Created by Jie Gao on 2018-11-09.
 */
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {StarStruckGameConfig} from "../../StarStruckGameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {MiniPayTable, miniPaytableSymbol} from "./MiniPayTable";

export class PortraitPaytable extends MiniPayTable {

    constructor(config:any) {
        super(config);
    }

    protected onChangeBet(bet:string):void {
        super.onChangeBet(bet);
        this.update();
    }

    protected createSymbolContainer(i:number):miniPaytableSymbol {
        const sprite:PIXI.Sprite = new PIXI.Sprite();
        const symbol:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(this._config.symbols[i] + "/" + this._config.symbols[i])[0]);
        symbol.scale.set(0.35, 0.35);
        symbol.anchor.set(0, 0);
        symbol.position.set(Helper.getSymbolPositions(1, 1)[0], Helper.getSymbolPositions(1, 1)[1]);

        const coinValue:number = 10;
        const text:PIXI.Text = new PIXI.Text(((coinValue * MathHelper.roundToDecimals(this._currentBet / 5, 2)).toFixed(2)).toString(), this._config.textStyle);
        symbol.position.set(0, 0);
        if(text.width > 100) {
            text.width = 100;
        }
        text.position.set(symbol.width / 2 - text.width / 2, 60);
        sprite.addChild(text);
        sprite.addChild(symbol);
        this._wrapper.addChild(sprite);
        return {
            symbol : sprite,
            text : text
        };
    }

    protected onResize(data:IResizeData):void {
        super.onResize(data);
        if(data.orientation != Orientation.PORTRAIT) {
            StageManager.getLayer(StarStruckGameConfig.instance.LAYERS.FOREGROUND.name).removeChild(this);
            return;
        }
        const isIPad:boolean = data.width / data.height >= 0.73;
        const scale:number = (isIPad?0.8:1);
        StageManager.getLayer(StarStruckGameConfig.instance.LAYERS.FOREGROUND.name).addChild(this);
        const width:number = GameConfig.instance.SYMBOL_WIDTH;
        const height:number = GameConfig.instance.SYMBOL_HEIGHT;
        const x0:number = Helper.getSymbolPositions(0, 0)[0];
        const y0:number = Helper.getSymbolPositions(0, 0)[1];
        this._wrapper.scale.set(scale, scale);
        this._wrapper.x = x0 - width * 0.87 + (isIPad?70:0);
        this._wrapper.y = y0 - 1.8 * height+ (isIPad?40:0);



        this._symbolSprites.forEach((symbolSprite:miniPaytableSymbol, i:number) => {
            symbolSprite.symbol.x = 25 + i * 105;
            symbolSprite.symbol.y = 20;
        });

        this._panel.clear();
        this._panel.beginFill(this._config.background.color, this._config.background.alpha);
        this._panel.drawRoundedRect(0, 0, this._symbolSprites[this._symbolSprites.length - 1].symbol.x - this._symbolSprites[0].symbol.x + 115, 120, 15);
        this._panel.endFill();
    }
}